import { IList } from 'annotation-tools/utils';
import React, { memo, useCallback, useMemo } from 'react';
import { IdType, ILabelType } from '../../../imports/annotation-canvas';
import {
  CropModeIcon,
  ModeButtonsView,
  ModeIconType,
  RectangleToolIcon
} from '../../../imports/ui-parts';
import { Percent } from '../../../imports/utils';
import { AppMode } from '../../../types/enum/app-mode';

export const ModeButtons = memo(
  ({
    tooltipMessages,
    appModeSelected,
    labels,
    labelSaturation,
    labelLightness,
    onLabelClick,
    onAppModeChange
  }: Readonly<{
    tooltipMessages: {
      cropImageMode: string;
      annotationMode: string;
    };
    appModeSelected: AppMode;
    labels: IList<ILabelType>;
    labelSaturation: Percent;
    labelLightness: Percent;
    onLabelClick: (id: IdType) => void;
    onAppModeChange: (id: AppMode) => void;
  }>) => {
    const buttons = useMemo<IList<ModeIconType<AppMode>>>(
      () =>
        IList([
          {
            id: 'crop-image',
            tooltipMessage: tooltipMessages.cropImageMode,
            IconComponent: CropModeIcon,
            useLabelMenu: false
          },
          {
            id: 'rectbox',
            tooltipMessage: tooltipMessages.annotationMode,
            IconComponent: RectangleToolIcon,
            useLabelMenu: true
          }
        ]),
      [tooltipMessages]
    );

    const onSelectedModeIdChange = useCallback(
      (id: IdType) => {
        switch (id) {
          case 'crop-image':
          case 'rectbox':
            onAppModeChange(id);
            break;
          default:
            break;
        }
      },
      [onAppModeChange]
    );

    return (
      <ModeButtonsView
        modeIcons={buttons}
        selectedModeId={appModeSelected}
        labels={labels}
        labelSaturation={labelSaturation}
        labelLightness={labelLightness}
        onSelectedModeIdChange={onSelectedModeIdChange}
        onLabelClick={onLabelClick}
      />
    );
  }
);

ModeButtons.displayName = 'ModeButtons';
